/* ===== ANESI · interactions + live Shopify cart ===== */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const R = window.routes || {};

  const lock = () => (document.body.style.overflow = 'hidden');
  const unlock = () => (document.body.style.overflow = '');
  const openBag = () => { $('#bag')?.classList.add('open'); $('#bagVeil')?.classList.add('open'); lock(); };
  const closeBag = () => { $('#bag')?.classList.remove('open'); $('#bagVeil')?.classList.remove('open'); unlock(); };
  const openMenu = () => { $('#mobileMenu')?.classList.add('open'); $('#mobileVeil')?.classList.add('open'); lock(); };
  const closeMenu = () => { $('#mobileMenu')?.classList.remove('open'); $('#mobileVeil')?.classList.remove('open'); unlock(); };

  document.addEventListener('click', (e) => {
    if (e.target.closest('#bagBtn')) { e.preventDefault(); openBag(); }
    if (e.target.closest('#bagClose') || e.target.id === 'bagVeil') closeBag();
    if (e.target.closest('#mobileBtn')) openMenu();
    if (e.target.closest('#mobileClose') || e.target.id === 'mobileVeil') closeMenu();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeBag(); closeMenu(); } });

  // ---- AJAX cart ----
  async function refreshDrawer() {
    try {
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'fetch' } });
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const newBag = doc.querySelector('#bag');
      const wasOpen = $('#bag')?.classList.contains('open');
      if (newBag && $('#bag')) {
        $('#bag').replaceWith(newBag);
        if (wasOpen) openBag();
      }
    } catch (e) {}
  }
  async function updateCount() {
    try {
      const cart = await (await fetch(R.cart_url + '.js')).json();
      $$('.hdr-bag-count').forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
    } catch (e) {}
  }
  async function addToCart(form) {
    const btn = form.querySelector('[type=submit]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch(R.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || 'Could not add'); }
      await Promise.all([refreshDrawer(), updateCount()]);
      openBag();
      if (btn) btn.textContent = 'Added ✓';
    } catch (err) { if (btn) btn.textContent = err.message || 'Error'; }
    finally { if (btn) setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1300); }
  }
  async function changeQty(key, qty) {
    try {
      await fetch(R.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      await Promise.all([refreshDrawer(), updateCount()]);
    } catch (e) {}
  }
  document.addEventListener('submit', (e) => {
    if (e.target.matches('.p-quickform, form[data-ajax-cart]')) { e.preventDefault(); addToCart(e.target); }
  });
  document.addEventListener('click', (e) => {
    const qbtn = e.target.closest('.bag-qty button');
    if (qbtn) { const row = qbtn.closest('.bag-qty'); changeQty(row.dataset.key, parseInt(qbtn.dataset.qty, 10)); }
  });

  // ---- Visual-only UI ----
  document.addEventListener('click', (e) => {
    if (e.target.matches('.filter-row .chip')) {
      const row = e.target.closest('.filter-row');
      row.querySelectorAll('.chip').forEach((c) => c.classList.remove('chip-on'));
      e.target.classList.add('chip-on');
    }
    if (e.target.matches('.kit-size button')) {
      const g = e.target.closest('.kit-size');
      g.querySelectorAll('button').forEach((b) => b.classList.remove('on'));
      e.target.classList.add('on');
    }
    const fab = e.target.closest('.fab');
    if (fab) { fab.closest('.fabric-row')?.querySelectorAll('.fab').forEach((f) => f.classList.remove('fab-on')); fab.classList.add('fab-on'); }
  });

  // ---- Scroll reveal ----
  function initReveal() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('reveal-ready');
    const sel = '.sec-head,.product,.moment,.fab,.rev,.fit-card,.tx,.story-copy,.story-img,.build-panel,.build-img,.moment-card,.email-inner,.reviews-grid > *,.products > *';
    const els = $$(sel).filter((el) => !el.closest('.hdr,.ft,.bag,.mobile-menu'));
    if (!els.length) { document.documentElement.classList.remove('reveal-ready'); return; }
    els.forEach((el, i) => { el.classList.add('reveal-on'); el.style.setProperty('--rd', (i % 6) * 60 + 'ms'); });
    const io = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('revealed'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  }

  const ready = () => { initReveal(); updateCount(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
